/*/ toggle the dropdown links /*/
jQuery(".nav-burger").click(function(e){
    e.preventDefault();
    $el = jQuery(this);
    jQuery("#nav-mobile").slideToggle('slow');
});

/*Main Toggle */
jQuery(".navbar-toggle").click(function(e){
    e.preventDefault();
    $el = jQuery(this);
    jQuery("#primary-menu").toggleClass('display-visible');
    jQuery("#primary-menu").slideToggle('slow');   
   //jQuery(".navigation-sub-menu").css("display","none");
});

jQuery("#site-navigation ul.menu > li.menu-item-has-children, #site-navigation ul.menu > li.menu-item-has-children > ul > li.menu-item-has-children, .navigation-top-logistics ul#top-menu > li.menu-item-has-children").append('<a href="#" class="toogle-dropdown" aria-label="matson"><i class="fa fa-plus" aria-hidden="true1"></i><i class="fa fa-minus" aria-hidden="true"></i></a>');

jQuery(".blue-bar-navigation ul.menu > li.menu-item-has-children, .blue-bar-navigation ul.menu > li.menu-item-has-children > ul > li.menu-item-has-children, .blue-bar-navigation ul.menu > li.menu-item-has-children > ul > li.menu-item-has-children > ul > li.menu-item-has-children").append('<a href="#" class="toogle-dropdown" aria-label="matson"><i class="fa fa-plus" aria-hidden="true2"></i><i class="fa fa-minus" aria-hidden="true"></i></a>');
/*sub Toggle */
jQuery("#site-navigation ul.menu > li.menu-item-has-children > .toogle-dropdown > .fa-plus").click(function(e){
    e.preventDefault();    
    $el = jQuery(this).parents('li.menu-item-has-children');    
    //$el.find('ul.navigation-sub-menu').slideToggle('slow'); 
    $el.find('ul.navigation-sub-menu').css("display", "block"); 
    $el.toggleClass("opened");
 
});
jQuery("#site-navigation ul.menu > li.menu-item-has-children > .toogle-dropdown > .fa-minus").click(function(e){
    e.preventDefault();    
    $el = jQuery(this).parents('li.menu-item-has-children');    
    //$el.find('ul.navigation-sub-menu').slideToggle('slow'); 
    $el.find('ul.navigation-sub-menu').css("display", "none"); 
    $el.toggleClass("opened");
 
});
jQuery(".blue-bar-navigation ul.menu > li.menu-item-has-children > .toogle-dropdown, .blue-bar-navigation ul.menu > li.menu-item-has-children > ul > li.menu-item-has-children > .toogle-dropdown").click(function(e){
   
    e.preventDefault(); 		
    $el = jQuery(this).parent();				
    $el.find('>ul').slideToggle('slow');
    $el.toggleClass("opened");
});
/*second sub Toggle */
/*
jQuery("#site-navigation ul.menu > li.menu-item-has-children >ul >li.menu-item-has-children > .toogle-dropdown, .navigation-top-logistics ul#top-menu > li.menu-item-has-children > a").click(function(e){       

    e.preventDefault(); 		
    $el = jQuery(this).parents('.navigation-sub-menu>li.menu-item-has-children');    
    //$el.find('ul.more-sub-menu').slideToggle('slow');
    $el.find('ul.more-sub-menu').css("display", "block");
    $el.toggleClass("opened");
});
*/
$mi = jQuery("#site-navigation ul.menu > li.menu-item-has-children > .navigation-sub-menu > li.menu-item-has-children > .toogle-dropdown > .fa-minus");
$pus = jQuery("#site-navigation ul.menu > li.menu-item-has-children > .navigation-sub-menu > li.menu-item-has-children > .toogle-dropdown > .fa-plus");

$pus.css("display", "block");
$mi.css("display", "none");
jQuery("#site-navigation ul.menu > li.menu-item-has-children > .navigation-sub-menu > li.menu-item-has-children > .toogle-dropdown > .fa-plus").click(function(e){              	
        $el = jQuery(this).parents('.navigation-sub-menu>li.menu-item-has-children');    
        //$el.find('ul.more-sub-menu').slideToggle('slow');
        $el.find('ul.more-sub-menu').css("display", "block");
        $mi.css("display", "block");
        $pus.css("display", "none");
        $el.toggleClass("opened");
});

jQuery("#site-navigation ul.menu > li.menu-item-has-children > .navigation-sub-menu > li.menu-item-has-children > .toogle-dropdown > .fa-minus").click(function(e){       
        $el = jQuery(this).parents('.navigation-sub-menu>li.menu-item-has-children'); 
        //$el.find('ul.more-sub-menu').slideToggle('slow');
        $el.find('ul.more-sub-menu').css("display", "none");
        $mi.css("display", "none");
        $pus.css("display", "block");
        $el.toggleClass("opened");
});

jQuery("button.navbar-search").click(function(e){
    jQuery("#site-navigation form").show('slide');
    e.stopPropagation();
});
jQuery("#site-navigation form").click(function(e){
    e.stopPropagation();
});

jQuery("#route-map .btn").click(function(e){
    e.preventDefault();
    $(this).parents("#route-map").addClass("openmap");
    $("#route-map .routemapslide").addClass("expand");
});
jQuery(".close-map").click(function(e){
    e.preventDefault();
    $(this).parents("#route-map").removeClass("openmap");
    $("#route-map .routemapslide").removeClass("expand");
});
jQuery(document).ready(function () {
    jQuery("#btn").click(function () {
        jQuery("#1sttab").show();
		jQuery("#2ndtab").hide();
		jQuery("#btn2").removeClass( "active" );
		jQuery("#btn").addClass( "active" );
    });
    jQuery("#btn2").click(function () {
        jQuery("#2ndtab").show();
        jQuery("#1sttab").hide();
        jQuery("#btn").removeClass( "active" );
		jQuery("#btn2").addClass( "active" );
    });
    jQuery("#surcharge_btn").click(function () {
        jQuery("#surtab1").show();
        jQuery("#surtab2").hide();
        jQuery("#surcharge_btn2").removeClass( "active" );
        jQuery("#surcharge_btn").addClass( "active" );
    });
    jQuery("#surcharge_btn2").click(function () {
        jQuery("#surtab2").show();
        jQuery("#surtab1").hide();
        jQuery("#surcharge_btn").removeClass( "active" );
        jQuery("#surcharge_btn2").addClass( "active" );
    });
    jQuery("#keyword_search").on("keyup", function() {
    var value = jQuery(this).val().toLowerCase();
    jQuery("#myTable span").filter(function() {
        jQuery(this).toggle(jQuery(this).text().toLowerCase().indexOf(value) > -1)
    });
    });
});


